<ng-template #modalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
  <div class="modal-body">
    <div [innerHTML]="body"></div>

    <form [formGroup]="form" novalidate>
      @for (input of inputs; track input) {
        <div class="form-group">
          @if (input.label) {
            <label [for]="'input_' + input.name">{{input.label}}</label>
          }
          <input [type]="input.type" class="form-control" [id]="'input_' + input.name" [placeholder]="input.label || 'Eingabe'" [formControlName]="input.name">
          @if (!form.controls[input.name].valid && !form.controls[input.name].untouched) {
            <small class="text-danger">
              {{ "Template.PromptModalComponent.msg_fillField" | translate }}.
            </small>
          }
        </div>
      }
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">
      {{ "Common.btn_cancel" | translate }}
    </button>

    <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="!form.valid">
      {{ "Common.btn_confirm" | translate }}
    </button>
  </div>
</ng-template>